import { render } from "./LeftNav.vue?vue&type=template&id=97127222&scoped=true"
import script from "./LeftNav.vue?vue&type=script&lang=js"
export * from "./LeftNav.vue?vue&type=script&lang=js"

import "./LeftNav.vue?vue&type=style&index=0&id=97127222&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97127222"]])

export default __exports__